import React from 'react';
import RowHeaders from './row_headers';
import ColumnHeaders from './column_headers';
import SubColumnHeaders from './subcolumn_headers';
import CellParticipantList from './cell_participant_list';
import Selectable from '../common/selectable';

const ViewerTable = React.createClass({

  render: function() {
    let rows = this._getRows(this.props.columns);
    
    return (
      <div style={{display: this.props.display}} className="abl-viewer-table">
        <div
          className="abl-unhide-columns-button" 
          onClick={this.props.onUnhideColumnsClick}
          style={{display: this.props.unHideColumnsButtonDisplay}}
          >
          Show All
        </div>
        <div ref="columnHeaders" className="abl-horizontal-scrollable">
          <div className="abl-row-header-spacer"></div>
          <table className="abl-table abl-col-headers">
            <tbody>
              <ColumnHeaders columns={this.props.columns} {...this.props} />
              <SubColumnHeaders columns={this.props.columns} {...this.props} />
            </tbody>
          </table>
        </div>
        <div className="abl-vertical-scrollable">
          <RowHeaders 
              display={this.props.rowHeadersDisplay} 
              items={this.props.rowHeaders} />
          <div onScroll={this.handleScroll} className="abl-horizontal-scrollable">
            <table className="abl-table">
              <tbody>
                {rows}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  },

  handleScroll: function(e) {
    this.refs.columnHeaders.scrollLeft = e.target.scrollLeft;
  },

  _getRows: function(columns) {
    let rows = columns.map((column, i) => {
      return this._getSubColumns(column.subColumns);
    });

    return (
      <tr>
        {rows}
      </tr>
    );
  },


  _getSubColumns: function(subColumns) {
    return subColumns.items.map((subColumn, i) => {
      let cells = this._getCells(subColumn.rows);
      
      return (
        <td className={`abl-col ${subColumn.className}`} key={i+1}>
          <div className="abl-sub-col">
            {cells}
          </div>
        </td>
      );
    });
  },

  _getMeetingClassNames(scheduledMeeting) {
    let classNames = [];
    if(scheduledMeeting.associated_to_inspected) {
      classNames.push('abl-associated');
    }
    return classNames;
  },

  _getCells: function(cells) {
    cells = cells || [];
    return cells.map((cell, i) => {
      return (
        <Selectable 
          key={i}
          id={cell.id}
          data={cell}
          overrideClick={true}
          selected={cell.scheduledMeeting.inspected}
          selectedClass="abl-selected"
          className={this._getMeetingClassNames(cell.scheduledMeeting).join(' ')}>
          <div
            className="abl-row"
            data-duration={cell.duration}
            style={{height: cell.height}}
            data-start-time={cell.scheduledMeeting.start_time}
            onClick={this.handleCellClick}
            >
            <div 
              className={`abl-cell ${cell.scheduledMeeting.classNames.join(' ')}`}
              data-meeting-id={cell.scheduledMeeting.id}
              data-cell-id={cell.id}
              data-scheduled={cell.scheduledMeeting.scheduled}
              tabIndex="0">
              <div className="abl-meeting-name" title={cell.scheduledMeeting.name}>
                {cell.scheduledMeeting.name}
              </div>
              <CellParticipantList
                participants={cell.participants} />
            </div>
          </div>
        </Selectable>
      );
    });
  },

  handleCellClick: function(selectable) {
    let selected = selectable.toggleSelect();

    if(this.lastSelected && this.lastSelected.isMounted()) {
      this.lastSelected.unselect();
    }

    this.props.onCellChange(
      selectable.props.id, 
      selectable, 
      selectable.props.data, 
      selected
    );

    this.lastSelected = selectable;
    
  }

});

export default ViewerTable;


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/viewer_table.js
 **/